import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_ACTIVITY_FEED_ACTION_TYPE } from '../actions/activityFeed.actions';

const initialState = null;

const activityFeedReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_ACTIVITY_FEED_ACTION_TYPE.SET_ACTIVITY_FEED:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default activityFeedReducer;
